<template>
  <div id="home" style="overflow-x: hidden">
    <Hbeheader v-on:childByValue="childByValue"></Hbeheader>
    <!--国家/省/市/房型-->
    <HBEPos v-if="tabName == '1'"> </HBEPos>
    <Hbecountry v-if="tabName == '2'"> </Hbecountry>
    <HBEMatchHarpId v-if="tabName == '3'"> </HBEMatchHarpId>
    <HBEAreaLocation v-if="tabName == '4'"> </HBEAreaLocation>
    <Hbeprovince v-if="tabName == '5'"> </Hbeprovince>
    <Hbecity v-if="tabName == '6'"> </Hbecity>
    <Hberoomtype v-if="tabName == '7'"> </Hberoomtype>
    <HBEFacility v-if="tabName == '8'"> </HBEFacility>
    <HBESource v-if="tabName == '9'"> </HBESource>
    <HBERC v-if="tabName == '10'"> </HBERC>
    <HbeHotelMarker v-if="tabName == '12'"> </HbeHotelMarker>
    <HbeCostCenter v-if="tabName == '13'"> </HbeCostCenter>
    <HBEGlobalNotify v-if="tabName == '14'"> </HBEGlobalNotify>
    <HBEVirtualCard v-if="tabName == '15'"> </HBEVirtualCard>
  </div>
</template>

<script>
import Hbeheader from "@/views/HBEConfig/HBEHeader";
import Hbecity from "@/views/HBEConfig/HBECity";
import Hbeprovince from "@/views/HBEConfig/HBEProvince";
import Hbecountry from "@/views/HBEConfig/HBECountry";
import Hberoomtype from "@/views/HBEConfig/HBERoomtype";
import HBEFacility from "@/views/HBEConfig/HBEFacility";
import HBESource from "@/views/HBEConfig/HBESource";
import HBERC from "@/views/HBEConfig/HBERC";
import HBEGlobalNotify from "@/views/HBEConfig/HBEGlobalNotify";
import HbeHotelMarker from "@/views/HBEConfig/HbeHotelMarker";
import HbeCostCenter from "@/views/HBEConfig/HBECostCenter";
import ClientList from "@/components/ClientList.vue";
import HBEMatchHarpId from "@/views/HBEConfig/HBEMatchHarpId";
import HBEAreaLocation from "@/views/HBEConfig/HBEAreaLocation";
import HBEPos from "@/views/HBEConfig/HBEPos";
import HBEVirtualCard from "@/views/HBEConfig/HBEVirtualCard";
export default {
  name: "HBEConfig",
  components: {
    Hbeheader,
    Hbecity,
    Hbeprovince,
    Hbecountry,
    Hberoomtype,
    HBEFacility,
    HBESource,
    HBERC,
    HbeHotelMarker,
    HbeCostCenter,
    ClientList,
    HBEGlobalNotify,
    HBEMatchHarpId,
    HBEAreaLocation,
    HBEPos,
    HBEVirtualCard
  },
  data() {
    return {
      tabName: "1",
    };
  },
  methods: {
    childByValue: function (tab) {
      this.tabName = tab;
      // if (this.tabName == "1") {
      //   this.posshow = true;
      // }
      // console.log(this.tabName);
      // Object.keys(this.dataForm).forEach((key) => {
      //   this.dataForm[key] = "";
      // });
      // Object.keys(this.searchForm).forEach((key) => {
      //   this.searchForm[key] = "";
      // });
      // this.searchForm.client = "";
      // this.btnshow = "";
    },

  },
};
</script>

<style scoped>
/* .hotel_container {
  height: 100%;
} */
::v-deep .el-button--primary {
  color: #fff;
  background-color: #e6a23c;
  border-color: #e6a23c;
}

::v-deep .el-form-item__error {
  margin-left: 85px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  content: " ";
  width: 0px;
  margin-right: 0px;
}

/*dialog*/
.select-btn {
  color: #fc6640;
  cursor: pointer;
}

.search-btn {
  margin: 2% 5%;
}

.search-input {
  margin-left: 10%;
}

.myBtn /deep/ .el-button {
  padding: 7px 20px !important;
  border: 1px solid #fc6640 !important;
  color: #fc6640 !important;
}

::v-deep .dialog-one .el-dialog__body {
  padding: 0px;
}

::v-deep .el-input__inner {
  height: 2.7rem;
  line-height: 2.7rem;
}


::v-deep .el-input__icon {
  height: auto;
  width: 2.5rem;
  text-align: center;
  line-height: 0;
}

.myselect_inner /deep/ .el-input__inner {
  height: 2.7rem;
  border-radius: 0;
  margin-top: 0.5rem;
}

.myicon_inner /deep/ .el-input__suffix {
  /*top: 0.7rem;*/
}

.pos {
  margin-left: 2rem;
  font-size: 1.5rem;
  font-weight: bold;
  border-bottom-color: gainsboro;
  border-bottom-style: solid;
  /*margin-top: 1rem;*/
  padding: 1rem 0 1rem 0;
}

.fontcenter {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  font-size: 1.3rem;
}

/*HarpID*/
::v-deep .btn-custom-cancel {
  float: right;
  margin-left: 10px;
  /*margin-right: 90px;*/
}

.btn-custom-cancel {
  float: right;
  margin-left: 0px;
  margin-right: 90px;
}

.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
